import React from "react";
import OrderCanceling from "./OrderCanceling";

const OrderDetail = ({ order, curenTime, removeOrder, isDeleting, setDeleting, withPenalty }) => {
  if (isDeleting) {
    return <OrderCanceling setDeleting={setDeleting} removeOrder={removeOrder} withPenalty={withPenalty} />;
  }

  return (
    <div className="order-receipt">
      <div className="order-receipt__border">
        <div className="order-receipt__salon">
          <div className="photo">
            <img src={order.studio?.images?.[0]} alt="salon photo" />
          </div>
          <div className="info">
            <div className="studio-name">{order.studio?.title}</div>
            <div className="studio-address">{order.studio?.address}</div>
          </div>
        </div>

        <div className="order-receipt__date">
          <div className="date-item">
            <div className="title">Appointment Time</div>
            <div className="info info-red">{order.from}</div>
          </div>
          <div className="date-item">
            <div className="title">Date Booking</div>
            <div className="info">{order.createdAt}</div>
          </div>
          <div className="date-item">
            <div className="title">Session start time</div>
            <div className="info info-time">
              <div className="time">{order.startTime}</div>
              <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                <circle cx="2" cy="2" r="2" fill="#D6D6DB" />
              </svg>
              <div className="duration">{order.durationSession} Hours</div>
            </div>
          </div>
          <div className="date-item">
            <div className="title">Payment Status</div>
            <div className="info">{order.status?.label}</div>
          </div>
        </div>

        <div className="order-receipt__price">
          <div className="price-service">
            <div className="title">{order.services?.[0]?.service?.title}</div>
            <div className="cost">{order.price} €</div>
          </div>
          <div className="price-tottal">
            <div className="title">Amount Payable</div>
            <div className="cost">{order.price} €</div>
          </div>
        </div>
      </div>
      {order.status?.value === "going" && (
        <div className="order-receipt__cancel">
          <button type="button" className="beauty-btn border cancel" onClick={() => setDeleting(true)}>
            Cancel Booking
          </button>
        </div>
      )}
    </div>
  );
};

export default OrderDetail;
